module.exports = __webpack_public_path__ + "img/eth.a9709f9a.svg";